<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <span :class="customClass" v-bind="attrs" v-on="on">{{ data | truncate(lengthDataToTruncate, '...') }}</span>
    </template>
    <span>{{ data }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'TruncateDataWithTooltip',
  props: {
    data: {
      default: () => ''
    },
    lengthDataToTruncate: {
      default: () => 10,
      type: Number
    },
    customClass: {
      type: String,
      default: ''
    }
  }
};
</script>

<style></style>
